import { useAuthStore } from "@/store/auth/auth.store";
import { AxiosInstance, CanceledError, InternalAxiosRequestConfig, isAxiosError } from "axios";

type SessionRequest = InternalAxiosRequestConfig & {
    clerkSessionId?: string | null;
    clerkRetried?: boolean;
};

export function installClerkInterceptors(client: AxiosInstance) {
    client.interceptors.request.use(async (config: SessionRequest) => {
        const { sessionId, getToken } = useAuthStore.getState();
        const token = await getToken({ skipCache: config.clerkRetried });
        if (sessionId !== useAuthStore.getState().sessionId) {
            throw new CanceledError("Session changed");
        }
        config.clerkSessionId = sessionId;
        if (token) config.headers.set("Authorization", `Bearer ${token}`);
        else config.headers.delete("Authorization");
        return config;
    });
    client.interceptors.response.use(
        (response) => {
            if (
                (response.config as SessionRequest).clerkSessionId !==
                useAuthStore.getState().sessionId
            ) {
                throw new CanceledError("Session changed");
            }
            return response;
        },
        async (error: unknown) => {
            if (!isAxiosError(error)) throw error;
            const config = error.config as SessionRequest | undefined;
            const { sessionId } = useAuthStore.getState();
            if (config && config.clerkSessionId !== sessionId)
                throw new CanceledError("Session changed");
            if (error.response?.status === 401 && config && sessionId && !config.clerkRetried) {
                config.clerkRetried = true;
                return client.request(config);
            }
            throw error;
        },
    );
}
